import React from "react";

import { WEB_V2_SOURCE_SCREENS } from "@vahak/core/dist/constants/event-names";

import { useCompactFlowAppTracker } from "../compact-flow/useCompactFlowAppTracker";
import { CompactLoadPostingProvider } from "./CompactLoadPostingProvider";

/**
 * App-level host for the compact load posting flow.
 *
 * Mounts `CompactLoadPostingProvider` once at the top of the tree so any consumer
 * surface (side nav, dashboard, marketplace, profile) can open the compact flow.
 * Posting i18n namespaces are fetched when the modal opens (`loadI18nNamespaces`).
 */
const CompactLoadPostingAppProvider = ({ children }: React.PropsWithChildren<{}>) => {
    const { trackEvent } = useCompactFlowAppTracker();

    return (
        <CompactLoadPostingProvider
            trackEvent={trackEvent}
            eventData={{ source_screen: WEB_V2_SOURCE_SCREENS.LOAD_FORM }}
        >
            {children}
        </CompactLoadPostingProvider>
    );
};

export default CompactLoadPostingAppProvider;
